export default __webpack_public_path__ + "static/media/math.a8b95f3e.svg";